import { createContext } from 'react'
import { Action, PremiumInsightsState, INITIAL_STATE } from './reducer'

interface ContextState extends PremiumInsightsState {
  dispatch: React.Dispatch<Action>
}

const defaultValue = {
  ...INITIAL_STATE,
  dispatch: () => null,
}

const PremiumInsightsContext = createContext<ContextState>(defaultValue)

export default PremiumInsightsContext
